import { lazy } from 'react';
import KeepAlive from 'react-activation';
import Loading from '../components/Loading';
import { Suspense } from "react";

const App = lazy(() => import('@/layouts/App'));
const Pending = lazy(() => import('@/pages/enter-portal/pending/Pending'));
const MyRequest = lazy(() => import('@/pages/enter-portal/my-request/MyRequest'));
const Handled = lazy(() => import('@/pages/enter-portal/handled/Handled'));
const Completed = lazy(() => import('@/pages/enter-portal/completed/Completed'));
const MyCopyTo = lazy(() => import('@/pages/enter-portal/my-copy-to/MyCopyTo'));
const enterPortalRoutes = [
    {
        path: "/layout",
        name: 'App',
        element: <App />,
        children: [
            {
                path: 'pending',
                name: '我的待办',
                element: <KeepAlive name='/layout/pending'>
                    <Suspense fallback={<Loading />}>
                        <Pending/>
                    </Suspense>
                </KeepAlive>
            },
            {
                path: 'myRequest',
                name: '我的发起',
                element: <KeepAlive name='/layout/myRequest'>
                    <Suspense fallback={<Loading />}>
                        <MyRequest/>
                    </Suspense>
                </KeepAlive>
            },
            {
                path: 'handled',
                name: '我的已办',
                element: <KeepAlive name='/layout/handled'>
                    <Suspense fallback={<Loading />}>
                        <Handled/>
                    </Suspense>
                </KeepAlive>
            },
            {
                path: 'completed',
                name: '我的办结',
                element: <KeepAlive name='/layout/completed'>
                    <Suspense fallback={<Loading />}>
                        <Completed/>
                    </Suspense>
                </KeepAlive>
            },
            {
                path: 'myCopyTo',
                name: '我的抄送',
                element: <KeepAlive name='/layout/myCopyTo'>
                    <Suspense fallback={<Loading />}>
                        <MyCopyTo/>
                    </Suspense>
                </KeepAlive>
            },
        ]
    },
]
export default enterPortalRoutes